<template>
    <section class="user-profile-settings-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="user-profile-settings-sidebar">
                        <el-tabs v-model="activeName" tab-position="left" class="user-profile-settings-tabs d-flex">
                            <el-tab-pane label="Edit Profile" name="edit-profile">
                                <user-profile-edit />
                            </el-tab-pane>
                            <el-tab-pane label="Change Password" name="change-password">
                                <user-profile-change-password />
                            </el-tab-pane>
                            <el-tab-pane label="Email Settings" name="email-settings">
                                <user-profile-email-setting />
                            </el-tab-pane>
                            <el-tab-pane label="Delete Account" name="delete-account-settings">
                                <user-profile-delete />
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import UserProfileChangePassword from './UserProfileChangePassword.vue'
import UserProfileEdit from './UserProfileEdit.vue'
import UserProfileEmailSetting from './UserProfileEmailSetting.vue'
import UserProfileDelete from './_UserProfileDelete.vue'

export default {
    name: 'UserProfileSettings',
    components: {
        UserProfileEdit,
        UserProfileChangePassword,
        UserProfileEmailSetting,
        UserProfileDelete,
    },
    data() {
        return {
            activeName: 'edit-profile'
        }
    }
}
</script>